import axios from './http';
// import axiosapi from 'axios'
// import { jsonp } from 'vue-jsonp';
// import jsonp from '../libs/jsonp'

// import CONFIG from '@/config/index.js'


export const getwximg = params => axios.get('/api/site/getloginqrcode', params);
export const getloginstatus = params => axios.get('/api/user/loginbyqrcode', params);
export const sendcode = params => axios.get('/api/user/sendcode', params);
export const stulogin = params => axios.get('/api/user/login', params);
export const getselectData = () => axios.get('/api/site/select');
export const getselectLabelData = params => axios.get('/api/site/selectlabel',params);

export const getToken = () => axios.get('/api/site/gettoken');
export const get_detail = params => axios.get('/api/resume/getdetail', params);

// export const save_resume = params => axios.post('/api/resume/save', params);
export const save_resume = params => axios.post('/api/resume/savebasicinfo', params);

export const getattachment = params => axios.get('/api/resume/getattachment', params);
export const uploadfile = params => axios.post('/api/resume/upload', params,{timeout:15000});
export const deluploadfile = params => axios.get('/api/resume/deleteattachment', params);

export const getwantpoi = params => axios.get('/api/position/getpositionintention', params);
// export const saveresume = params => axios.post('/api/resume/save', params);
export const savewantpoi = params => axios.post('/api/position/savepositionintention',params);
export const getcollegemajors = params => axios.get('/api/school/getcollegemajors',params);
export const getcommon = params => axios.get('/api/user/getcommon',params);
// ai简历
// 保存简历基本信息
export const aiSaveBasicInfo = params => axios.post('/api/resume/savebasicinfo',params);
// 保存意向职位
export const aiSavePositionInfo = params => axios.post('/api/airesume/savewish',params);
// 教育经历
export const aiSaveedu = params => axios.post('/api/resume/saveedu',params);
// 删除教育经历
export const aiDelEdu = params => axios.post('/api/resume/deledu',params);
//  实习经历
export const aiSavework = params => axios.post('/api/resume/savework',params);
//  删除实习经历
export const aiDelwork = params => axios.post('/api/resume/delwork',params);
//  删除静项目经历
export const aiDelproject = params => axios.post('/api/resume/delproject',params);
//  保存项目
export const aiSaveproject = params => axios.post('/api/resume/saveproject',params);
// 保存其他
export const aiSaveother = params => axios.post('/api/resume/saveother',params);
//  获取简历模板
export const getAiResumeTemplate = params => axios.post('/api/example/get',params);






// WEBPACK FOOTER //
// ./src/api/request.js